import { combineReducers } from 'redux';
import appReducer from './app/reducer';
import authReducer from './auth/reducer';
import errorReducer from './error/reducer';
import existingAccountsReducer from './existing-accounts/reducer';
import experimentsReducer from './experiments/reducer';
import flowReducer from './flow/reducer';
import googleRecaptchaReducer from './google-recaptcha/reducer';
import httpResponsesReducer from './http-responses/reducer';
import integrationsReducer from './integrations/reducer';
import loadingReducer from './loading-status/reducer';
import signupDataReducer from './signup-data/reducer';
import typeaheadReducer from './typeahead/reducer';
export const rootReducer = combineReducers({
  appState: appReducer,
  auth: authReducer,
  error: errorReducer,
  existingAccounts: existingAccountsReducer,
  experiments: experimentsReducer,
  flow: flowReducer,
  httpResponses: httpResponsesReducer,
  integrations: integrationsReducer,
  loadingStatus: loadingReducer,
  signupData: signupDataReducer,
  googleRecaptcha: googleRecaptchaReducer,
  typeahead: typeaheadReducer
});